/**
 * JIM-1015-01 (Jim 2026-10-15): a final inspection is filed only after every construction stage
 * has its completion date — the report he saw said FINAL INSPECTION over "Landscaping /
 * Stabilization / Permanent BMPs — In Progress". Returns the stages still missing one, in the
 * order the table shows them; an empty list means the final inspection may go ahead.
 */
export function stagesWithoutCompletion(
  stages: { stage_name: string; stage_order: number }[],
  dates: Record<string, { completion?: string } | undefined>
): string[] {
  return [...stages]
    .sort((a, b) => a.stage_order - b.stage_order)
    .filter((s) => !dates[s.stage_name]?.completion?.trim())
    .map((s) => s.stage_name);
}
